import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginFacade, NotificationFacade } from '@ridango/components';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';

@Component({
    template: ''
})
export class OidcAuthPageComponent extends BaseComponent implements OnInit {
    constructor(
        private readonly route: ActivatedRoute,
        private readonly loginFacade: LoginFacade,
        private readonly notification: NotificationFacade,
        private readonly router: Router,
        private readonly translate: TranslateService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscribeToOidcAuthCallback();
    }

    private subscribeToOidcAuthCallback(): void {
        this.route.queryParams
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((queryParams) => this.handleOidcAuthQueryParams(queryParams));
    }

    private handleOidcAuthQueryParams(queryParams: Record<string, string>): void {
        const exchangeId = queryParams.exchangeId;
        const oidcError = queryParams.error;

        if (oidcError) {
            this.notification.error(this.translate.instant(oidcError), {
                showAfterRouteChange: true
            });
            this.router.navigate([this.translate.currentLang, 'login']);
            return;
        }

        if (!exchangeId) {
            this.router.navigate([this.translate.currentLang, 'login']);
            return;
        }

        this.loginFacade.loginWithOidcExchange(exchangeId);
        this.router.navigate([this.translate.currentLang, 'login']);
    }
}
